import { useState } from "react";
import useFetch from "../hooks/useFetch";
import config from "../config";
import "./Notification.css";

const Notification = () => {
  //stav popupu
  const [showPopup, setShowPopup] = useState(true);

  //fetch zpravy
  const { loading, error, data } = useFetch(
    `${config.api}/api/important-notice`
  );

  // možné stavy při/po fetchi
  if (loading) return <></>;
  if (error) return <></>;

  //? test
  //? console.log("title", data);

  //metoda pro zavreni popupu
  const handleClose = () => {
    setShowPopup(false);
  };
  return (
    <>
      {data?.data && showPopup && (
        <div className="notification" style={{ display: "flex" }}>
          <h3>{data.data.title}</h3>
          <span>{data.data.text}</span>
          <br />
          <button className="btn" onClick={handleClose}>
            Zavřít
          </button>
        </div>
      )}
    </>
  );
};
export default Notification;
